import { render, staticRenderFns } from "./InquiryList.vue?vue&type=template&id=81350506&scoped=true&"
import script from "./InquiryList.vue?vue&type=script&lang=js&"
export * from "./InquiryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81350506",
  null
  
)

component.options.__file = "InquiryList.vue"
export default component.exports